/* tslint:disable */
/* eslint-disable */
/**
 * Risks API
 * API for managing risks.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CreateAddressDto } from './CreateAddressDto';
import {
    CreateAddressDtoFromJSON,
    CreateAddressDtoFromJSONTyped,
    CreateAddressDtoToJSON,
    CreateAddressDtoToJSONTyped,
} from './CreateAddressDto';
import type { CreateNaturalPersonCommandDto } from './CreateNaturalPersonCommandDto';
import {
    CreateNaturalPersonCommandDtoFromJSON,
    CreateNaturalPersonCommandDtoFromJSONTyped,
    CreateNaturalPersonCommandDtoToJSON,
    CreateNaturalPersonCommandDtoToJSONTyped,
} from './CreateNaturalPersonCommandDto';

/**
 * 
 * @export
 * @interface CreateLegalEntityCommandDto
 */
export interface CreateLegalEntityCommandDto {
    /**
     * Optional identifier for the legal entity
     * @type {string}
     * @memberof CreateLegalEntityCommandDto
     */
    id?: string;
    /**
     * Company designation/name
     * @type {string}
     * @memberof CreateLegalEntityCommandDto
     */
    companyName: string;
    /**
     * Identifier for the legal form of the company
     * @type {string}
     * @memberof CreateLegalEntityCommandDto
     */
    legalFormId: string;
    /**
     * 
     * @type {CreateAddressDto}
     * @memberof CreateLegalEntityCommandDto
     */
    address: CreateAddressDto;
    /**
     * French phone number
     * @type {string}
     * @memberof CreateLegalEntityCommandDto
     */
    phone: string;
    /**
     * Email address of the company
     * @type {string}
     * @memberof CreateLegalEntityCommandDto
     */
    email: string;
    /**
     * List of natural persons associated with the legal entity
     * @type {Array<CreateNaturalPersonCommandDto>}
     * @memberof CreateLegalEntityCommandDto
     */
    naturalPersons?: Array<CreateNaturalPersonCommandDto>;
    /**
     * SIRET number of the company
     * @type {string}
     * @memberof CreateLegalEntityCommandDto
     */
    registrationNumber: string;
    /**
     * Company capital amount
     * @type {number}
     * @memberof CreateLegalEntityCommandDto
     */
    capital: number;
    /**
     * RCS registration city
     * @type {string}
     * @memberof CreateLegalEntityCommandDto
     */
    rcsCity: string;
    /**
     * RCS registration number
     * @type {string}
     * @memberof CreateLegalEntityCommandDto
     */
    rcsNumber: string;
    /**
     * ORIAS registration number
     * @type {string}
     * @memberof CreateLegalEntityCommandDto
     */
    oriasNumber?: string | null;
    /**
     * Professional civil liability insurance
     * @type {string}
     * @memberof CreateLegalEntityCommandDto
     */
    rcp?: string | null;
    /**
     * OrganizationUnit (ABP) to attach the entity to. Used by admins when creating a
     * subscriber on behalf of a target plateforme — the entity becomes visible to that
     * plateforme's corporate managers. If omitted, the current user's plateforme is used.
     * 
     * @type {string}
     * @memberof CreateLegalEntityCommandDto
     */
    plateformeId?: string | null;
}

/**
 * Check if a given object implements the CreateLegalEntityCommandDto interface.
 */
export function instanceOfCreateLegalEntityCommandDto(value: object): value is CreateLegalEntityCommandDto {
    if (!('companyName' in value) || value['companyName'] === undefined) return false;
    if (!('legalFormId' in value) || value['legalFormId'] === undefined) return false;
    if (!('address' in value) || value['address'] === undefined) return false;
    if (!('phone' in value) || value['phone'] === undefined) return false;
    if (!('email' in value) || value['email'] === undefined) return false;
    if (!('registrationNumber' in value) || value['registrationNumber'] === undefined) return false;
    if (!('capital' in value) || value['capital'] === undefined) return false;
    if (!('rcsCity' in value) || value['rcsCity'] === undefined) return false;
    if (!('rcsNumber' in value) || value['rcsNumber'] === undefined) return false;
    return true;
}

export function CreateLegalEntityCommandDtoFromJSON(json: any): CreateLegalEntityCommandDto {
    return CreateLegalEntityCommandDtoFromJSONTyped(json, false);
}

export function CreateLegalEntityCommandDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateLegalEntityCommandDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'companyName': json['companyName'],
        'legalFormId': json['legalFormId'],
        'address': CreateAddressDtoFromJSON(json['address']),
        'phone': json['phone'],
        'email': json['email'],
        'naturalPersons': json['naturalPersons'] == null ? undefined : ((json['naturalPersons'] as Array<any>).map(CreateNaturalPersonCommandDtoFromJSON)),
        'registrationNumber': json['registrationNumber'],
        'capital': json['capital'],
        'rcsCity': json['rcsCity'],
        'rcsNumber': json['rcsNumber'],
        'oriasNumber': json['oriasNumber'] == null ? undefined : json['oriasNumber'],
        'rcp': json['rcp'] == null ? undefined : json['rcp'],
        'plateformeId': json['plateformeId'] == null ? undefined : json['plateformeId'],
    };
}

export function CreateLegalEntityCommandDtoToJSON(json: any): CreateLegalEntityCommandDto {
    return CreateLegalEntityCommandDtoToJSONTyped(json, false);
}

export function CreateLegalEntityCommandDtoToJSONTyped(value?: CreateLegalEntityCommandDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'companyName': value['companyName'],
        'legalFormId': value['legalFormId'],
        'address': CreateAddressDtoToJSON(value['address']),
        'phone': value['phone'],
        'email': value['email'],
        'naturalPersons': value['naturalPersons'] == null ? undefined : ((value['naturalPersons'] as Array<any>).map(CreateNaturalPersonCommandDtoToJSON)),
        'registrationNumber': value['registrationNumber'],
        'capital': value['capital'],
        'rcsCity': value['rcsCity'],
        'rcsNumber': value['rcsNumber'],
        'oriasNumber': value['oriasNumber'],
        'rcp': value['rcp'],
        'plateformeId': value['plateformeId'],
    };
}

